import { ProgressItem, ProgressItemState } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { getExerciseIconSrc } from '../assets';
import { SKELETON_DUMMYTEXT } from '../base/constants';
import { isChallengeWorkoutId } from '../base/utils';
import { ExerciseSelectors } from '../exercise';
import { IState } from '../store/state';
import * as Selectors from './selectors';
import { SessionActions } from './slice';

export interface ISessionProgressItemOwnProps {
  workoutId: number;
  index: number;
}

export interface ISessionProgressItemProps extends ISessionProgressItemOwnProps {
  completed: boolean;
  disabled: boolean;
  exerciseName: string | null;
  locked: boolean;
  isWorkoutRunning: boolean;
  onWorkoutSelect: (index: number) => void;
}

export const SessionProgressItemFC: React.FC<ISessionProgressItemProps> = ({
  completed,
  disabled,
  exerciseName,
  locked,
  workoutId,
  index,
  onWorkoutSelect,
  isWorkoutRunning,
}) => {
  const { t } = useTranslation();

  if (disabled) {
    return null;
  }
  const isChallenge = isChallengeWorkoutId(workoutId);
  const challengePostfix = isChallenge ? 'Challenge' : '';
  const exerciseTitle = !exerciseName
    ? SKELETON_DUMMYTEXT
    : t(`common.exercises:Title.${exerciseName}${challengePostfix}`);
  const iconSrc = exerciseName ? getExerciseIconSrc(exerciseName, completed, locked) : undefined;
  const selectable = !!exerciseName && !completed && !locked && !isWorkoutRunning;
  const onSelect = () => onWorkoutSelect(index);
  let progressState: ProgressItemState;
  if (completed) {
    progressState = ProgressItemState.Done;
  } else if (locked) {
    progressState = ProgressItemState.None;
  } else {
    progressState = ProgressItemState.Active;
  }
  return (
    <ProgressItem
      label={exerciseTitle}
      name={exerciseName ?? `${workoutId}`}
      iconSrc={iconSrc}
      state={progressState}
      selectable={selectable}
      onSelect={onSelect}
    />
  );
};

export const mapStateToProps = (state: IState, ownProps: ISessionProgressItemOwnProps) => {
  const completed = Selectors.isWorkoutCompleted(state, ownProps.index);
  const disabled = Selectors.isWorkoutDisabled(state, ownProps.index);
  const exerciseName = Selectors.getExerciseName(state, ownProps.workoutId);
  const locked = Selectors.isWorkoutLocked(state, ownProps.workoutId);
  const isWorkoutRunning = ExerciseSelectors.isWorkoutRunning(state);
  return {
    completed,
    disabled,
    exerciseName,
    locked,
    isWorkoutRunning,
  } as ISessionProgressItemProps;
};

export const mapDispatchToProps = {
  onWorkoutSelect: SessionActions.openWorkout,
};

const SessionProgressItem = connect(mapStateToProps, mapDispatchToProps)(SessionProgressItemFC);
SessionProgressItem.displayName = 'SessionProgressItem';
export default SessionProgressItem;
